export const ROUTES = {
  signup: '/signup',
  login: '/login',
  forgotPassword: '/forgot-password',
  appPage: 'https://stockup.vn/',
  dashboard: '/',
  manageInvestments: '/danh-muc-dau-tu',
  followCompany: '/danh-muc-theo-doi',
  homePage: '/',
  newsStockMarket: '/tin-thi-truong-chung-khoan',
  highLightByStockup: '/gia-co-phieu-theo-von-hoa-thi-truong',
  stockAnalysis: '/phan-tich-co-phieu-mien-phi',
  derivativeVN30: '/chung-khoan-phai-sinh',
  upgradeFuturesPackage: '/dang-ky-chung-khoan-phai-sinh',
  profile: '/profile',
  stockPage: '/chung-khoan',
};

export const ROUTES_NO_REACT = {
  adminUser: '/quan-ly-a369/users',
  adminPackage: '/quan-ly-a369/packages',
  upgradePackage: '/upgrade',
  companies: '/danh-sach-cong-ty',
  securitiesCompanies: '/danh-sach-cong-ty-chung-khoan',
  securitiesCompany: '/them-cong-ty-chung-khoan',
  analyticsTransaction: '/thong-ke-giao-dich',
  statisticalValueTransaction: '/thong-ke-gia-tri-giao-dich',
  statisticalVolumeTransaction: '/thong-ke-khoi-luong-giao-dich',
};

export const ADMIN_ROUTES = {
  users: '/quan-ly-a369/users',
  packages: '/quan-ly-a369/packages',
  tokens: '/quan-ly-a369/tokens',
  news: '/quan-ly-a369/tin-tuc',
  appSettings: '/quan-ly-a369/app-setting',
  trendingPage: '/quan-ly-a369/trending-page',
  notificationLog: '/quan-ly-a369/notification-log',
  propick: '/quan-ly-a369/propick',
  trending: '/quan-ly-a369/trending',
  trading: '/quan-ly-a369/trading',
  sendEmail: '/quan-ly-a369/gui-email',
  aiAgentQuestion: '/quan-ly-a369/ai-agent-question',
  userQuestion: '/quan-ly-a369/user-questions',
};
